import React from "react";
import {
  Datagrid,
  DateField,
  List,
  TextField,
  Create,
  SimpleForm,
  TextInput,
  
  BooleanField,
  ReferenceField,
  
  BooleanInput,
  ReferenceArrayInput,
  SelectArrayInput,
  ImageInput,
  SingleFieldList,
  ChipField,
  ReferenceManyField,
  ImageField,
} from "react-admin";
import RichTextInput from "ra-input-rich-text";
import Edit from "./components/Edit";


export const BlogList = (props) => {
  return (
    
    <List
      {...props}
     
    >
      <Datagrid rowClick="edit">
        <TextField source="title" />

        <BooleanField source="isActive" />
        <BooleanField source="isHomePage" />
        <DateField source="createdAt" />

        <ReferenceManyField label="Comments by" reference="User" target="blog_some">
                <SingleFieldList>
                    <ChipField source="name" />
                </SingleFieldList>
            </ReferenceManyField>
      </Datagrid>
    </List>
  );
};
const BlogFormInput = ({ ...props }) => {

  return (
    <SimpleForm {...props} warnWhenUnsavedChanges>
      <TextInput source="title" />

      <RichTextInput source="content" />
      <BooleanInput source="isActive" />
      <BooleanInput source="isHomePage" />


      <ReferenceArrayInput source="authorIds" reference="User"  label= "Yazar (Sadece 1 tane seçiniz!!)">
          <SelectArrayInput optionText="name" />
          
        </ReferenceArrayInput>

      <ReferenceField
      label="Current Image"
      source="image.id"
      reference="File"
      allowEmpty
    >
      <ImageField source="url" title="title" />
    </ReferenceField>

 
    <ImageInput source="imageId" label="New Image" accept="image/*">
        <ImageField source="src" title="title" />
      </ImageInput>
    
    </SimpleForm>
  );
};
export const BlogEdit = (props) => (
  <Edit {...props}>
    <BlogFormInput />
  </Edit>
);

export const BlogCreate = (props) => {
  // Read the dayId from the location which is injected by React Router and passed to our component by react-admin automatically
  return (
    <Create {...props}>
      <BlogFormInput />
    </Create>
  );
};
